module.exports = __webpack_public_path__ + "img/FMS-Bus.7935fd8e.png";